import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDeletePlanState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DeletePlanEmptyState: IDeletePlanState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
